// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/regional-component-lists/detail-form/detail-form.css
// module id = 4190
// module chunks = 0